import { useEffect, useState } from "react";
import HiringSettingsPanel from "../settings/HiringSettingsPanel";

const TABS = [
  { id: "policies", label: "Hiring policies" },
  { id: "ids", label: "ID formats" },
  { id: "mandatory", label: "Mandatory fields" },
];

/**
 * Hiring settings — opened from Global Settings → Hiring, or ?tab=settings.
 * Portal SMTP / templates / alerts / notifications live under Notification emails.
 */
export default function PortalSettingsPanel({ canEdit, initialSub = "policies" }) {
  const [activeTab, setActiveTab] = useState(() => {
    const sub = String(initialSub || "policies");
    if (["policies", "ids", "mandatory"].includes(sub)) return sub;
    // legacy portal sub → ID formats (email settings moved to Notification emails)
    if (sub === "portal" || sub === "pace") return sub === "portal" ? "ids" : "policies";
    return "policies";
  });

  useEffect(() => {
    const sub = String(initialSub || "policies");
    if (["policies", "ids", "mandatory"].includes(sub)) {
      setActiveTab(sub);
    } else if (sub === "portal") {
      setActiveTab("ids");
    } else if (sub === "pace") {
      setActiveTab("policies");
    }
  }, [initialSub]);

  return (
    <div className="min-h-0 flex-1 text-[hsl(var(--ds-fg))]">
      <div className="mb-4">
        <h1 className="ds-h2">Hiring settings</h1>
        <p className="ds-caption mt-1 text-[hsl(var(--ds-muted-fg))]">
          Configure from Global Settings → Hiring. Policies, ID formats, and mandatory
          fields. Portal SMTP and email alerts are under Notification emails.
        </p>
      </div>

      <div className="mb-4 flex flex-wrap gap-2 border-b border-[hsl(var(--ds-border))] pb-2">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={
              activeTab === tab.id
                ? "rounded-xl border border-[hsl(var(--ds-primary))] bg-[hsl(var(--ds-surface))] px-4 py-2 text-sm font-semibold text-[hsl(var(--ds-primary))] shadow-sm"
                : "rounded-xl border border-transparent px-4 py-2 text-sm font-medium text-[hsl(var(--ds-muted-fg))] hover:bg-[hsl(var(--ds-muted))] hover:text-[hsl(var(--ds-fg))]"
            }
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <HiringSettingsPanel canEdit={canEdit} initialTab={activeTab} hideTabs />
    </div>
  );
}
